export const SEED_LIST_TITLE_ID = 'seeds-list-title';
export const SEED_LIST_DESCRIPTION_ID = 'seeds-list-description';
